module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Sun-fog-b13597b5c581997a17dee9d06ba60965.svg";